<template>
  <div id="list">
    <Aside />
    <div class="trade">
      <!-- TITRE + RECHERCHE -->
      <div class="title">
        <h1>Vos partenaires Gimontois</h1>
        <div class="searchContainer">
          <div class="searchBoxList">
            <input
              type="text"
              list="filtreComList"
              placeholder="Recherchez un commerce"
              v-model="search"
              v-on:keyup="searchFilter(search)"
            />
            <datalist id="filtreComList">
              <option
                v-for="activity in activityArray"
                :key="activity"
                :value="activity"
              >
                {{ activity }}
              </option>
            </datalist>
          </div>
          <div
            class="resetBtn"
            @click="
              search = '';
              searchFilter('tout');
            "
          >
            <i class="fas fa-times"></i>
          </div>
        </div>
      </div>

      <!-- FILTRES -->
      <div class="filtres">
        <a @click="filterBtn = !filterBtn" class="blackBtn">Filtres</a>
        <div v-if="filterBtn == true" class="activeFilter">
          <a
            @click="
              searchFilter('tout');
              filterBtn = false;
            "
            >TOUT</a
          >
          <a
            v-for="filter in activityArray"
            :key="filter"
            @click="
              searchFilter(filter);
              filterBtn = false;
            "
            >{{ filter }}</a
          >
        </div>
      </div>

      <!-- LISTE DES DIFFERENTS COMMERCES -->
      <div class="shopList">
        <div class="shopLocation" v-for="(trader, i) in realTrader" :key="i">
          <div class="shopCard">
          <h2>{{ trader.denomination_socialeE }}</h2>
          <p class="yellowPara">{{ trader.activiteE }}</p>
          <p class="services">{{ trader.services_et_produitsE }}</p>
          <p class="boldPara" v-if="trader.contact_nomE != 'NULL'">
            <span v-if="trader.civiliteE && trader.civiliteE != 'NULL'">{{
              trader.civiliteE
            }}</span>
            {{ trader.contact_nomE }}
          </p>
          <p v-if="trader.adresseE != '' && trader.adresseE != 'NULL'">
            {{ trader.adresseE }} <br> {{ trader.villeE }}
          </p>
          <p
            class="boldPara"
            v-if="trader.telE && trader.telE != '' && trader.telE != 'NULL'"
          >
            Tél: {{ replaceCarcBySpace(trader.telE) }}
          </p>
          <div class="communications">
            <a
              :href="'tel:' + deleteCarcNum(trader.telE)"
              v-if="trader.telE && trader.telE != '' && trader.telE != 'NULL'"
              :title="deleteCarcNum(trader.telE)"
              @click="getCurrentIndexTel(trader.idE)"
              ><i class="fal fa-phone-alt"></i
            ></a>
            <a
              :href="`mailto:${trader.emailE}`"
              v-if="
                trader.emailE && trader.emailE != '' && trader.emailE != 'NULL'
              "
              :title="trader.emailE"
              @click="getCurrentIndexMail(trader.idE)"
              ><i class="fal fa-envelope"></i
            ></a>
            <a
              v-if="
                trader.site_webE &&
                trader.site_webE != '' &&
                trader.site_webE != 'NULL'
              "
              :href="trader.site_webE"
              :title="trader.site_webE"
              target="_blank"
              rel="noopener"
              ><i class="fal fa-globe"></i
            ></a>
            <a
              v-if="
                trader.facebookE &&
                trader.facebookE != '' &&
                trader.facebookE != 'NULL'
              "
              :href="trader.facebookE"
              :title="trader.facebookE"
              target="_blank"
              rel="noopener"
              ><i class="fab fa-facebook-f"></i
            ></a>
            <a
              v-if="
                trader.instagramE &&
                trader.instagramE != '' &&
                trader.instagramE != 'NULL'
              "
              :href="trader.instagramE"
              :title="trader.instagramE"
              target="_blank"
              rel="noopener"
              ><i class="fab fa-instagram"></i
            ></a>
            <a
              v-if="
                trader.twitterE &&
                trader.twitterE != '' &&
                trader.twitterE != 'NULL'
              "
              :href="trader.twitterE"
              :title="trader.twitterE"
              target="_blank"
              rel="noopener"
              ><i class="fab fa-twitter"></i
            ></a>
            <a
              v-if="
                trader.linkedINE &&
                trader.linkedINE != '' &&
                trader.linkedINE != 'NULL'
              "
              :href="trader.linkedINE"
              :title="trader.linkedINE"
              target="_blank"
              rel="noopener"
              ><i class="fab fa-linkedin-in"></i
            ></a>
          </div>
          <div class="plus" v-if="currentIndexMail == trader.idE">
            <p>{{trader.emailE}}</p>
          </div>
          <div class="plus" v-if="currentIndexTel == trader.idE">
            <p>{{trader.telE}}</p>
          </div>
          <router-link
            class="fiche"
            v-if="trader.is_adherentE == 1"
            :to="{
              name: 'Details',
              params: {
                id: trader.idE,
                title: deleteSpace(
                  deleteParenthesis(trader.denomination_socialeE.toLowerCase())
                ),
              },
            }"
            >Voir la fiche</router-link
          >
          <!-- <a href="/" class="opinionBtn">
                <i class="fas fa-star"></i>
                <p>Avis</p>
              </a> -->

          </div>
        </div>
      </div>

      <!-- BOUTON RETOUR -->
      <div class="fullBtn">
        <router-link to="/" class="backBtn">Accueil</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Aside from "../components/Aside";
import { shopMixin } from "../mixins/shopMixin";
import { titleMixin } from "../mixins/titleMixin";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Liste des acteurs économiques gimontois. Filtres par activité et recherche par activité et nom de l'entreprise. Coordonnées des partenaires économiques Vie économique gimontoise à Gimont dans le Gers.",
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "Listing, Acteurs économiques, Coordonnées, Vie économique, Gimont, Gers",
      },
    ],
  },
  name: "List",
  components: {
    Aside,
  },
  mixins: [shopMixin, titleMixin],
  data() {
    return {
      title: "Liste des commerçants Vie économique gimontoire Gimont Gers 32",
      search: "",
      filterBtn: false,
      currentIndexMail: 0,
      currentIndexTel: 0,
    };
  },
  computed: {
    realTrader: function() {
      let realTraderArray = [];
      for(let i = 0; i< this.traderArray.length; i++) {
        if(this.traderArray[i].idE != 275) {
          realTraderArray.push(this.traderArray[i]);
        }
      }
      return realTraderArray;
    }
  },
  beforeMount() {
    this.getParam();
  },
  mounted() {
    this.searchFilter(this.search);
  },
  methods: {
    getParam() {
      if (this.$route.params.search) {
        let keyWord = this.$route.params.search;
        keyWord.trim();
        keyWord = keyWord.split("_").join(" ");
        this.search = keyWord;
      } else {
        this.search = "";
      }
    },
    getCurrentIndexMail(index) {
      this.currentIndexMail = index;
    },
    getCurrentIndexTel(index) {
      this.currentIndexTel = index;
    }
  },
};
</script>

<style>
.trade h1 {
  margin: 0;
}

.trade {
  padding: 4rem 3rem;
  margin-left: 18%;
}

.trade .title {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  padding: 1rem 0;
  border-bottom: 1px solid #3c4652;
}

.trade .title h1 {
  text-align: left;
  font-size: 1.8rem;
  margin-right: auto;
}

.trade .searchContainer {
  display: flex;
  align-items: center;
}

.trade .title input {
  border: 1px lightgray solid;
}
.resetBtn {
  width: 30px;
  height: 30px;
  margin-left: 8px;
  border: 2px #d89747 solid;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #d89747;
  color: white;
  transition: 0.3s ease;
}
.resetBtn:hover {
  background: white;
  color: #d89747;
}
.resetBtn i {
  font-weight: bold;
  font-size: 1.3em;
}
.trade .filtres {
  margin: 2rem 0;
}

.trade .filtres .activeFilter {
  margin: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid rgba(255, 234, 170, 0.555);
  padding: 1rem;
}

.trade .filtres .activeFilter a {
  color: #3c4652;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border: 1px dashed #3c4652;
  margin: 0.5rem 0.5rem;
}

.trade .filtres .activeFilter a:hover {
  color: #d89747;
  border: 1px dashed #d89747;
}

.trade .shopList {
  /* display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	margin-top: 1rem; */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1em;
}

.trade .shopLocation {
  border: 1px solid #d8974773;
  /* width: 18%; */
  position: relative;
  padding: 0.5rem;
  margin: 0 0.4rem 1rem 0;
  padding-bottom: 3rem;
}

.trade .services {
  display: none;
}

.trade .shopLocation p {
  margin: 0;
  padding: 0;
}

.trade .shopLocation h2 {
  text-transform: uppercase;
  font-size: 1.2rem;
  text-align: left;
}

.trade .yellowPara {
  color: #d89747;
}

.trade .boldPara {
  font-weight: bold;
}

.trade .communications {
  display: flex;
  justify-content: space-evenly;
  margin-top: 1rem;
  font-size: 1.4rem;
}

.trade .communications a {
  color: #3c4652;
}

.trade .opinionBtn {
  border: 1px solid #f0f1f7;
  background-color: #f0f1f7;
  display: flex;
  width: 30%;
  padding: 0.5rem;
  justify-content: space-evenly;
  margin-top: 2rem;
  border-radius: 2px;
}

.trade .opinionBtn i,
.opinionBtn p {
  color: #555771;
}

.trade .opinionBtn:hover {
  border: 1px solid #555771;
  background-color: #555771;
}

.trade .opinionBtn:hover i,
.opinionBtn:hover p {
  color: #f0f1f7;
}

.trade .fullBtn {
  margin-top: 3rem;
  width: 100%;
}

.trade .fullBtn .backBtn {
  float: right;
}

.trade .fiche {
  position: absolute;
  bottom: 0;
  text-align: center;
  left: 0;
  right: 0;
  background-color: #d89747;
  cursor: pointer;
  padding: 0.5rem 0;
  transition: all 0.5s ease;
}

.trade .fiche:hover {
  background-color: #3c4652;
  transition: all 0.5s ease;
  color: #d89747;
}

.trade .plus {
  text-align: center;
  font-weight: bold;
  padding: .5rem;
}

@media all and (max-width: 1300px) {
  /* .trade .shopLocation {
		width: 26%;
	} */
}

@media all and (max-width: 1000px) {
  .trade {
    margin: 0;
  }

  .trade .title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .trade .searchContainer {
    width: 100%;
  }
  .trade .title .searchBoxList,
  .title input {
    width: 98%;
  }
  /* .trade .shopLocation {
		width: 30%;
	} */
}

@media all and (max-width: 700px) {
  /* .trade .shopLocation {
		width: 45%;
	} */
}

@media all and (max-width: 600px) {
  .trade .shopLocation {
    /* width: 100%; */
    text-align: center;
  }
}

@media all and (max-width: 500px) {
  .trade {
    padding: 2rem;
  }

  .trade .title h1,
  .trade .shopLocation h2 {
    text-align: center;
  }
}
</style>
